import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { AppConstants } from '../const/constent';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClassSessionService {

  public apiURL: string = AppConstants.apiBaseUrl;

  constructor(private http: HttpClient) {}

  submitSessionFeedback(_formValues: any): Observable<any> {
    const url = this.apiURL + `feedback`;
    return this.http.post(url, _formValues);
  }

  submitSessionIssueReport(_formValues: any): Observable<any> {
    const url = this.apiURL + `report/issue`;
    return this.http.post(url, _formValues);
  }
}
